import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=70c0511a&scoped=true&"
import script from "./invitation.vue?vue&type=script&lang=js&"
export * from "./invitation.vue?vue&type=script&lang=js&"
import style0 from "./invitation.vue?vue&type=style&index=0&id=70c0511a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c0511a",
  null
  
)

export default component.exports